export const tableHeader = [
  'Test Name',
  'Student Name',
  'Status',
  'Time left',
  'Approve',
  'Reject'
]
